<app-base-modal
  [title]="'Артикулы'"
>
  <div class="container">
    <mat-form-field appearance="outline">
      <mat-label>Поиск</mat-label>
      <input
        matInput
        [(ngModel)]="searchValue"
        (ngModelChange)="filterArticles()"
      >
    </mat-form-field>
   <div class="cards">
     @for (item of filterArticles(); track $index) {
       <div class="article-card">
         <div class="article-card-header">
           <span class="article-id">Артикул ID: {{ item.nmId || item.id }}</span>
           <button
             mat-stroked-button
             color="warn"
             (click)="handleDetach(item.nmId || item.id || 0)"
           >
             Отвязать
           </button>
         </div>
         <div
           class="article-title"
           [matTooltip]="item.title"
           matTooltipShowDelay="500"
         >
           {{ item.title }}
         </div>
       </div>
     }
   </div>
  </div>
  <div class="buttons-container">
    <button
      mat-button
      tabindex="-1"
      color="warn"
      (click)="closeDialog('cancel')"
    >
      Закрыть
    </button>
  </div>
</app-base-modal>
